import { createEntityAdapter } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { categoriesActions } from './categories-actions';
import { CategoriesState, PromptCategory } from './models';

export const categoriesAdapter = createEntityAdapter<PromptCategory>();

export const categoriesInitialState: CategoriesState = categoriesAdapter.getInitialState({
  uncategorized: null,
  loaded: false,
});

export const categoriesReducer = createReducer(
  categoriesInitialState,

  on(categoriesActions.loadCategoriesSuccess, (state, { categories }) =>
    sortCategories(categoriesAdapter.setAll(categories, state)),
  ),

  on(categoriesActions.loadCategories, state => ({ ...state, loaded: false })),

  on(categoriesActions.loadUncategorizedSuccess, (state, { uncategorized }) => ({
    ...state,
    uncategorized,
  })),

  on(categoriesActions.loadCategoriesSuccess, categoriesActions.loadCategoriesFailure, state => ({
    ...state,
    loaded: true,
  })),

  on(categoriesActions.clearAllCategories, state => categoriesAdapter.removeAll(state)),

  on(categoriesActions.createCategorySuccess, (state, { category }) =>
    sortCategories(categoriesAdapter.addOne(category, state)),
  ),

  on(categoriesActions.editCategorySuccess, (state, { category }) =>
    sortCategories(categoriesAdapter.updateOne({ id: category.id, changes: category }, state)),
  ),

  on(categoriesActions.deleteCategorySuccess, (state, { categoryId }) =>
    categoriesAdapter.removeOne(categoryId, state),
  ),
);

export const categoriesFeature = createFeature({
  name: 'categories',
  reducer: categoriesReducer,
});

function sortCategories(state: CategoriesState): CategoriesState {
  const sortedCategories = [...state.ids].sort((a, b) => {
    const categoryA = state.entities[a];
    const categoryB = state.entities[b];

    if (categoryA && categoryB) {
      return categoryA.name.localeCompare(categoryB.name);
    }

    return 0;
  });

  return categoriesAdapter.setAll(
    sortedCategories.map(id => state.entities[id]),
    state,
  );
}
